export const getParsedSpecies = (data: any[]) => {
  return data?.map((x: any) => ({
    id: x?.id,
    label: x?.label,
    value: x?.integration_id,
    integrationId: x?.integration_id,
  }));
};

export const getParsedBreeds = (data: any[]) => {
  return data?.map((x: any) => ({
    id: x?.id,
    label: x?.label,
    value: x?.integration_id,
    integrationId: x?.speciesId,
    speciesId: x?.species_id,
  }));
};

export const getParsedGenders = (data: any[]) => {
  return data?.map((x: any) => ({
    value: x?.id,
    label: x?.label,
    integrationId: x?.integration_id,
  }));
};
